import { FC, PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ReiniciarScroll: FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();

  // Reseteo el scroll cuando navego entre paginas
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [location.pathname]);

  return <>{children}</>;
};

export default ReiniciarScroll;
